/**
 * Sprawdza czy przekazana wartość jest obiektem.
 *
 * @param {any} value - wartość do sprawdzenia
 * @return {boolean}
 */
const isObject = value => Boolean(value && value.constructor === Object);

export default isObject;
